class StepChangedListen {
    constructor(sound) {
        this.grandpaSound = sound;
    }
    stepChanged(step) {
        this.grandpaSound.setStep(step);
    }
}
export class GrandpaSound {
    constructor(sound) {
        this.step = 1;
        this.stepChangedListener = new StepChangedListen(this);
        this.sound = sound;
    }
    setStep(step) {
        const prevStep = this.step;
        this.step = step;
        if (prevStep === 3 && this.step === 4) {
            this.sound.play("grandpaEffect");
        }
    }
}
//# sourceMappingURL=grandpaSound.js.map